/* MIXUNIO — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = document.documentElement.classList.contains('shopify-design-mode');

  /* ---------- Titulares que entran palabra a palabra ---------- */
  function initSplit(root) {
    (root || document).querySelectorAll('.mt-split:not([data-split])').forEach(function (el) {
      el.setAttribute('data-split', '1');
      var i = 0;
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'mt-w';
              var s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
        });
      };
      walk(el);
    });
  }

  /* ---------- Un único observador para todas las entradas ---------- */
  var io = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal, .mt-split, [data-mt-in]');
    if (reduce || design || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  /* ---------- Hero: parallax con el ratón ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('.mt-hero').forEach(function (hero) {
      if (hero.dataset.ready) return; hero.dataset.ready = '1';
      var intro = hero.querySelector('.mt-hero__intro');
      if (intro) requestAnimationFrame(function () { setTimeout(function () { intro.classList.add('is-in'); }, 80); });
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      var raf = null;
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { hero.style.setProperty('--mx', x.toFixed(3)); hero.style.setProperty('--my', y.toFixed(3)); });
      });
      hero.addEventListener('pointerleave', function () { hero.style.setProperty('--mx', 0); hero.style.setProperty('--my', 0); });
    });
  }

  /* ---------- Tarjetas que se inclinan hacia el cursor ---------- */
  function initTilt(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('.mt-tilt').forEach(function (card) {
      if (card.dataset.tilt) return; card.dataset.tilt = '1';
      var max = parseFloat(card.getAttribute('data-tilt-max') || '5');
      card.addEventListener('pointermove', function (ev) {
        var r = card.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        card.style.transitionDelay = '0s';
        card.style.transform = 'perspective(1100px) rotateX(' + (-y * max).toFixed(2) + 'deg) rotateY(' + (x * max).toFixed(2) + 'deg) translateZ(0)';
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagnet(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('.mt-magnet').forEach(function (b) {
      if (b.dataset.mag) return; b.dataset.mag = '1';
      b.addEventListener('pointermove', function (ev) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((ev.clientX - r.left - r.width / 2) * 0.18).toFixed(1) + 'px,' + ((ev.clientY - r.top - r.height / 2) * 0.28).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Efectos ligados al scroll (pasos + anatomía) ---------- */
  var scrollers = [];
  function onScroll() {
    scrollers.forEach(function (fn) { fn(); });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { onScroll(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', onScroll);

  function initSteps(root) {
    (root || document).querySelectorAll('.mt-steps').forEach(function (s) {
      if (s.dataset.ready) return; s.dataset.ready = '1';
      var line = s.querySelector('.mt-steps__line');
      if (!line) return;
      scrollers.push(function () {
        var r = s.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height * 0.9)));
        line.style.setProperty('--p', p.toFixed(3));
      });
    });
  }

  function initAnatomy(root) {
    (root || document).querySelectorAll('.mt-anat').forEach(function (a) {
      if (a.dataset.ready) return; a.dataset.ready = '1';
      var track = a.querySelector('.mt-anat__track');
      var items = a.querySelectorAll('.mt-anat__item');
      var hots = a.querySelectorAll('.mt-anat__hot');
      var cam = a.querySelector('.mt-anat__cam');
      var box = a.querySelector('.mt-anat__box');
      var num = a.querySelector('[data-anat-num]');
      var bar = a.querySelector('.mt-anat__bar');
      var zoom = parseFloat(a.getAttribute('data-zoom') || '1.35');
      var n = items.length; if (!n) return;
      var current = -1;
      function set(i) {
        if (i === current) return; current = i;
        items.forEach(function (it, k) { it.classList.toggle('is-on', k === i); });
        hots.forEach(function (h, k) { h.classList.toggle('is-on', k === i); });
        var y = parseFloat(items[i].getAttribute('data-y') || '50');
        if (cam) {
          cam.style.setProperty('--cam-o', y + '%');
          cam.style.setProperty('--cam-s', zoom);
        }
        if (box) box.style.setProperty('--hot', y + '%');
        if (num) num.textContent = ('0' + (i + 1)).slice(-2);
        if (bar) bar.style.setProperty('--p', ((i + 1) / n).toFixed(3));
      }
      items.forEach(function (it, k) {
        it.addEventListener('click', function () {
          if (window.innerWidth <= 1100 || !track) { set(k); return; }
          var r = track.getBoundingClientRect();
          var top = window.scrollY + r.top + (k + 0.5) / n * (r.height - window.innerHeight);
          window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      set(0);
      var auto = null;
      scrollers.push(function () {
        if (window.innerWidth <= 1100) {
          if (!auto && !reduce) auto = setInterval(function () { set((current + 1) % n); }, 3600);
          return;
        }
        if (auto) { clearInterval(auto); auto = null; }
        var r = track.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var p = Math.min(0.999, Math.max(0, -r.top / total));
        set(Math.floor(p * n));
      });
      onScroll();
    });
  }

  /* ---------- Selector de colores ---------- */
  function initColors(root) {
    (root || document).querySelectorAll('.mt-colors').forEach(function (c) {
      if (c.dataset.ready) return; c.dataset.ready = '1';
      var stage = c.querySelector('.mt-colors__stage');
      var sw = c.querySelectorAll('.mt-swatch');
      var bs = c.querySelectorAll('.mt-colors__b');
      var names = c.querySelectorAll('.mt-colors__name span');
      var words = c.querySelectorAll('.mt-colors__word span');
      var link = c.querySelector('[data-color-link]');
      var prog = c.querySelector('.mt-colors__progress');
      var delay = parseInt(c.getAttribute('data-auto') || '0', 10);
      var cur = 0, timer = null;
      function go(i) {
        bs.forEach(function (b, k) {
          b.classList.remove('is-out');
          if (k === cur && k !== i) b.classList.add('is-out');
          b.classList.toggle('is-on', k === i);
        });
        [sw, names, words].forEach(function (list) { list.forEach(function (el, k) { el.classList.toggle('is-on', k === i); }); });
        if (sw[i]) {
          stage.style.setProperty('--cur-bg', sw[i].getAttribute('data-bg'));
          if (link && sw[i].getAttribute('data-url')) link.setAttribute('href', sw[i].getAttribute('data-url'));
        }
        cur = i;
        restart();
      }
      function restart() {
        if (!delay || reduce || design) return;
        clearTimeout(timer);
        if (prog) { prog.classList.remove('is-run'); void prog.offsetWidth; prog.classList.add('is-run'); }
        timer = setTimeout(function () { go((cur + 1) % sw.length); }, delay * 1000);
      }
      sw.forEach(function (s, k) { s.addEventListener('click', function () { go(k); }); });
      if (sw.length) go(0);
    });
  }

  /* ---------- FAQ con altura animada ---------- */
  function initFaq(root) {
    (root || document).querySelectorAll('.mt-faq__item').forEach(function (d) {
      if (d.dataset.ready) return; d.dataset.ready = '1';
      if (d.open) d.classList.add('is-open');
      d.querySelector('summary').addEventListener('click', function (ev) {
        ev.preventDefault();
        if (d.open) {
          d.classList.remove('is-open');
          setTimeout(function () { d.open = false; }, reduce ? 0 : 550);
        } else {
          d.open = true;
          requestAnimationFrame(function () { d.classList.add('is-open'); });
        }
      });
    });
  }

  /* ---------- Carrito: añadir y abrir el cajón de Dawn ---------- */
  function addToCart(id, qty, btn, msgEl) {
    var drawer = document.querySelector('cart-drawer');
    var body = { id: Number(id), quantity: qty || 1 };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    if (msgEl) msgEl.textContent = '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.status) { if (msgEl) msgEl.textContent = data.description || data.message || 'Something went wrong.'; return; }
      if (drawer && data.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else {
        window.location.href = root + 'cart';
      }
    }).catch(function () {
      window.location.href = root + 'cart';
    }).finally(function () {
      if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    });
  }
  window.mtAddToCart = addToCart;

  function initQuickAdd(root) {
    (root || document).querySelectorAll('[data-mt-add]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        addToCart(b.getAttribute('data-mt-add'), 1, b, null);
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    var v = (cents / 100);
    var withDelims = function (n, d, t, s) {
      var p = n.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return p.join(s);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withDelims(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withDelims(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelims(v, 0, '.', ',');
      return withDelims(v, 2, ',', '.');
    });
  }

  function initProduct(root) {
    (root || document).querySelectorAll('.mt-pdp').forEach(function (p) {
      if (p.dataset.ready) return; p.dataset.ready = '1';
      var dataEl = p.querySelector('[data-mt-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = p.getAttribute('data-money') || '${{amount}}';
      var form = p.querySelector('form[data-mt-form]');
      var idInput = form && form.querySelector('input[name="id"]');
      var btn = p.querySelector('[data-mt-submit]');
      var btnLabel = btn && btn.querySelector('.mt-btn__label');
      var priceEl = p.querySelector('[data-mt-price]');
      var compareEl = p.querySelector('[data-mt-compare]');
      var badgeEl = p.querySelector('[data-mt-badge]');
      var msg = p.querySelector('.mt-buy__msg');
      var qty = p.querySelector('.mt-qty input');
      var sticky = p.querySelector('.mt-sticky-buy');
      var stickyBtn = sticky && sticky.querySelector('[data-mt-sticky-add]');
      var stickyPrice = sticky && sticky.querySelector('[data-mt-sticky-price]');

      /* Galería */
      var slides = p.querySelectorAll('.mt-gal__slide');
      var thumbs = p.querySelectorAll('.mt-gal__thumb');
      var countEl = p.querySelector('[data-mt-count]');
      var cur = 0;
      function show(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); });
        if (countEl) countEl.textContent = ('0' + (cur + 1)).slice(-2) + ' / ' + ('0' + slides.length).slice(-2);
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = p.querySelector('[data-mt-prev]'), next = p.querySelector('[data-mt-next]');
      if (prev) prev.addEventListener('click', function () { show(cur - 1); });
      if (next) next.addEventListener('click', function () { show(cur + 1); });
      var main = p.querySelector('.mt-gal__main');
      if (main) {
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (sx === null) return; var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null;
        });
      }
      show(0);

      /* Variantes */
      function selected() {
        return Array.prototype.map.call(p.querySelectorAll('.mt-opt'), function (fs) {
          var c = fs.querySelector('input:checked');
          if (c) {
            var lbl = fs.querySelector('[data-mt-opt-val]');
            if (lbl) lbl.textContent = c.value;
          }
          return c ? c.value : (fs.getAttribute('data-fixed') || null);
        });
      }
      function update() {
        var opts = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, k) { return opts[k] === null || o === opts[k]; }); });
        if (!v) {
          if (btn) btn.setAttribute('disabled', 'disabled');
          if (btnLabel) btnLabel.textContent = btn.getAttribute('data-unavailable');
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, fmt);
        if (stickyPrice) stickyPrice.textContent = money(v.price, fmt);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) { compareEl.textContent = onSale ? money(v.compare_at_price, fmt) : ''; compareEl.hidden = !onSale; }
        if (badgeEl) {
          badgeEl.hidden = !onSale;
          if (onSale) badgeEl.textContent = (badgeEl.getAttribute('data-tpl') || 'Save [x]%').replace('[x]', Math.round((1 - v.price / v.compare_at_price) * 100));
        }
        if (btn) {
          if (v.available) { btn.removeAttribute('disabled'); if (btnLabel) btnLabel.textContent = btn.getAttribute('data-add'); }
          else { btn.setAttribute('disabled', 'disabled'); if (btnLabel) btnLabel.textContent = btn.getAttribute('data-soldout'); }
        }
        if (v.featured_media) {
          var idx = Array.prototype.findIndex.call(slides, function (s) { return s.getAttribute('data-media') == v.featured_media.id; });
          if (idx > -1) show(idx);
        }
        if (window.history.replaceState && p.getAttribute('data-url')) {
          window.history.replaceState({}, '', p.getAttribute('data-url') + '?variant=' + v.id);
        }
      }
      p.querySelectorAll('.mt-opt input').forEach(function (i) { i.addEventListener('change', update); });
      if (variants.length > 1) update();

      /* Cantidad */
      p.querySelectorAll('[data-mt-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-mt-qty'), 10));
          qty.value = n;
        });
      });

      if (form) form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        addToCart(idInput.value, parseInt(qty && qty.value, 10) || 1, btn, msg);
      });
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        addToCart(idInput.value, parseInt(qty && qty.value, 10) || 1, stickyBtn, msg);
      });

      /* Barra de compra fija cuando el botón sale de pantalla */
      if (sticky && btn && 'IntersectionObserver' in window) {
        var footer = document.querySelector('.mt-footer');
        var btnVisible = true, footVisible = false;
        var refresh = function () { sticky.classList.toggle('is-on', !btnVisible && !footVisible); };
        new IntersectionObserver(function (e) { btnVisible = e[0].isIntersecting || e[0].boundingClientRect.top > 0; refresh(); }).observe(btn);
        if (footer) new IntersectionObserver(function (e) { footVisible = e[0].isIntersecting; refresh(); }).observe(footer);
      }
    });
  }

  function initAll(root) {
    initSplit(root); initReveal(root); initHero(root); initTilt(root); initMagnet(root);
    initSteps(root); initAnatomy(root); initColors(root); initFaq(root); initQuickAdd(root); initProduct(root);
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Editor de Shopify: re-inicializar al editar una sección */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var it = e.target;
    if (it.classList && it.classList.contains('mt-anat__item')) it.click();
    if (it.classList && it.classList.contains('mt-swatch')) it.click();
  });
})();
